/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, inject, viewChild } from "@angular/core";
import { OptionDirective } from "../../../../directives/option.directive";
import { SelectOption } from "../../option/default/select-option.component";
import { MultipleSelectOptionAdapter } from "./multiple-select-option.adapter";

@Component({
    selector: "app-multiple-select-option",
    templateUrl: "./multiple-select-option.component.html",
    imports: [SelectOption, CommonModule, OptionDirective],
})
export class MultipleSelectOption extends MultipleSelectOptionAdapter<any> {
    directiveRef = viewChild(OptionDirective);
    changeRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        if (this.renderItem()) {
            const viewContainerRef = this.directiveRef()?.viewContainerRef;
            viewContainerRef?.clear();

            const componentRef = viewContainerRef?.createComponent<
                MultipleSelectOptionAdapter<any>
            >(this.renderItem());

            componentRef?.setInput("option", this.option());
            componentRef?.setInput("focus", this.focus());
            componentRef?.setInput("bindLabel", this.bindLabel());
            componentRef?.setInput("bindValue", this.bindValue());

            this.changeRef.detectChanges();

            this.focus$.subscribe({
                next: (focus) => {
                    componentRef?.setInput("focus", focus);
                },
            });

            componentRef?.instance.mouseEnter.subscribe(() => {
                this.mouseEnter.emit();
            });

            componentRef?.instance.mouseLeave.subscribe(() => {
                this.mouseLeave.emit();
            });
        }
    }
}
